webpackJsonp([35783957827783],{

/***/ 423:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"grid":"src-components-pages-Homepage----Homepage-module---grid---38nyG","contentWrapper":"src-components-pages-Homepage----Homepage-module---contentWrapper---38qIV"};

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dec, _class;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mobxReact = __webpack_require__(42);
	
	var _reactHelmet = __webpack_require__(169);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Gallery = __webpack_require__(82);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _HomepageModule = __webpack_require__(423);
	
	var _HomepageModule2 = _interopRequireDefault(_HomepageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Homepage = (_dec = (0, _mobxReact.inject)('UIStore'), _dec(_class = (0, _mobxReact.observer)(_class = function (_Component) {
	  _inherits(Homepage, _Component);
	
	  function Homepage(props) {
	    _classCallCheck(this, Homepage);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  Homepage.prototype.componentDidMount = function componentDidMount() {
	    this.props.UIStore.setStretchContentHeightFalse();
	  };
	
	  Homepage.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.props.UIStore.setStretchContentHeightTrue();
	  };
	
	  Homepage.prototype.render = function render() {
	    var _props = this.props,
	        gridImages = _props.gridImages,
	        children = _props.children,
	        UIStore = _props.UIStore;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Sue Dann Interiors' }),
	      _react2.default.createElement(
	        _Gallery2.default,
	        {
	          images: gridImages.slice(0, UIStore.windowWidth > 1200 ? 5 : 6),
	          gridClassName: _HomepageModule2.default.grid
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _HomepageModule2.default.contentWrapper },
	          children
	        )
	      )
	    );
	  };
	
	  return Homepage;
	}(_react.Component)) || _class) || _class);
	
	
	Homepage.propTypes = {
	  gridImages: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    title: _propTypes2.default.string,
	    path: _propTypes2.default.string
	  })),
	  children: _propTypes2.default.node,
	  UIStore: _propTypes2.default.object
	};
	
	exports.default = Homepage;
	module.exports = exports['default'];

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PageHeader = __webpack_require__(32);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _PageContent = __webpack_require__(31);
	
	var _PageContent2 = _interopRequireDefault(_PageContent);
	
	var _Homepage = __webpack_require__(303);
	
	var _Homepage2 = _interopRequireDefault(_Homepage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage(_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  var pageData = data.markdownRemark,
	      gallery = data.galleriesJson;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _Homepage2.default,
	      {
	        gridImages: gallery.images.map(function (image) {
	          return {
	            title: image.title,
	            path: 'homepage/' + image.path
	          };
	        })
	      },
	      _react2.default.createElement('main', { dangerouslySetInnerHTML: { __html: pageData.html } })
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = IndexPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-6c369f2db7ffcd30081f.js